import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { Mutations } from '@shared/api';
import { API } from '@shared/types/api';
import { notNil } from '@shared/util/notNil';

type CreateEntitiesFunction = (
  entities: API.CreateWorkflowEntity[],
) => Promise<
  NonNullable<
    NonNullable<API.CreateWorkflowEntitiesMutation['createWorkflowEntities']>['entities']
  >[number][]
>;

export function useCreateEntitiesMutation(workflowTemplateId: string): CreateEntitiesFunction {
  const [createEntities] = useMutation<
    API.CreateWorkflowEntitiesMutation,
    API.CreateWorkflowEntitiesMutationVariables
  >(Mutations.entity.createWorkflowEntities);

  return useCallback(
    async (entities: API.CreateWorkflowEntity[]) => {
      const input = {
        workflowTemplateId,
        entities,
      };
      const { data } = await createEntities({
        variables: { input },
      });

      const createdEntities = data?.createWorkflowEntities?.entities?.filter(notNil);

      if (createdEntities?.length === entities.length) {
        return createdEntities;
      } else {
        throw new Error('Failed to create entities');
      }
    },
    [workflowTemplateId, createEntities],
  );
}
